import '../locale-dd';
import '../notification-bell';
import '../role-toggle';
import '../profile-toggle';
import {TopHeader} from '@epg/epg-components'; // eslint-disable-line no-unused-vars

export default (ctx, html) => html`
<top-header
  class="shadow-sm d-print-none"
  style="width:100%;"
  name="${ctx.username}"
  .current_role=${ctx.currentRole}
  .notifications=${ctx.jobscount}
  .isloggedin=${ctx.loggedIn}
  .groupSettings=${ctx.settings}
  .selectedGroup=${ctx.selectedGroup}
  .isRootAdmin=${ctx.isRootAdmin}
  .orgType=${ctx.orgType}
  @setSeenJobs=${ctx.setSeenJobs}
  @logout="${ctx.logout}"
  usertype=${ctx.userType}
></top-header>
`;
